import React, { Suspense } from "react";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import ReactTooltip from "react-tooltip";
import { useSelector, useDispatch } from "react-redux";
import { applicationsActions } from "../../store";

import styles from "../../../styles/map.module.css";
import { useNavigate } from "react-router";

import Status from "./Status";
import Search from "./Search";
import DevicesList from "./DevicesList";
import Conf from "../../../conf";

const Player = React.lazy(() => import("./Player"));

const Sidebar = () => {
    const history = useNavigate();
    const dispatch = useDispatch();

    const user = useSelector((state) => state.session.user);
    const dialog = useSelector((state) => state.applications.dialog);
    const HaveRoute = useSelector((state) => state.applications.haveRoute);

    let dialogOverlay;
    let dialogOverlay_01;

    const exit = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className={styles.custom_ui}>
                        <h1>آیا برای خروج مطمعن هستید ؟</h1>
                        <button onClick={onClose}>خیر</button>
                        <button
                            onClick={() => {
                                onClose();
                                fetch(`${Conf.server_address}/session`, { method: "DELETE", credentials: "include" }).then(() => {
                                    sessionStorage.clear();
                                    localStorage.clear();
                                    var cookies = document.cookie.split(";");

                                    for (var i = 0; i < cookies.length; i++) {
                                        var cookie = cookies[i];
                                        var eqPos = cookie.indexOf("=");
                                        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                                        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                                    }

                                    history("/");
                                    window.location.reload();
                                });
                            }}
                        >
                            بله
                        </button>
                    </div>
                );
            },
        });
    };

    const closeDialog = (e) => {
        const isClickOutside = e.target === dialogOverlay || e.target === dialogOverlay_01;
        if (isClickOutside) dispatch(applicationsActions.dialog(undefined));
    };

    return (
        <>
            {dialog ? (
                <div className={"react-confirm-alert-overlay"} onClick={closeDialog} ref={(dom) => (dialogOverlay = dom)}>
                    <div className={"react-confirm-alert"} ref={(dom) => (dialogOverlay_01 = dom)}>
                        <div className={styles.custom_ui_01}>
                            {dialog === "Status" && <Status />}
                            {dialog === "Search" && <Search />}
                            {dialog === "DevicesList" && <DevicesList />}
                        </div>
                    </div>
                </div>
            ) : (
                []
            )}

            <div className={styles.right} style={{ height: 70 + (user.administrator ? 60 : 0) + (HaveRoute ? 60 : 0) + "px" }}>
                <div className={styles.panel}>
                    <div className={styles.managementGroup}>
                        <div className={styles.managementBtn} onClick={() => exit()}>
                            خروج
                        </div>
                        <div className={styles.managementBtn} onClick={() => dispatch(applicationsActions.dialog("DevicesList"))}>
                            دستگاه ها
                        </div>
                        <div className={styles.managementBtn} onClick={() => dispatch(applicationsActions.dialog("Search"))}>
                            تاریخچه
                        </div>
                        <div className={styles.managementBtn} onClick={() => dispatch(applicationsActions.dialog("Status"))}>
                            وضعیت
                        </div>
                    </div>
                    {user.administrator ? (
                        <div className={styles.managementGroup}>
                            <div className={styles.managementBtn} onClick={() => history("/management/users")} style={{ width: "calc(50% - 25px)", maxWidth: "200px" }}>
                                مدیریت کاربران
                            </div>

                            <div className={styles.managementBtn} onClick={() => history("/management/devices")} style={{ width: "calc(50% - 25px)", maxWidth: "200px" }}>
                                مدیریت دستگاه ها
                            </div>
                        </div>
                    ) : (
                        []
                    )}

                    {HaveRoute ? (
                        <div className={styles.managementGroup}>
                            <Suspense fallback={[]}>
                                <Player />
                            </Suspense>
                        </div>
                    ) : (
                        []
                    )}

                    <ReactTooltip id="Tooltip" type="warning" place="bottom" arrowColor="transparent" />
                </div>
            </div>
        </>
    );
};

export default Sidebar;
